import { Button, useTheme } from "@mui/material";
import { FC, useMemo } from "react";
import { useLocalization } from "../../../../hooks/useLocalization";

interface FilterButtonMobileProps {
  label: string;
  selectedCount: number;
  totalCount: number;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  emptySelectionMode?: "all" | "zero";
}

export const FilterButtonMobile: FC<FilterButtonMobileProps> = ({
  label,
  onClick,
  selectedCount,
  totalCount,
  emptySelectionMode = "all",
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  const actionText = useMemo(() => {
    if (selectedCount === 0) {
      const suffix =
        emptySelectionMode === "zero"
          ? "(0)"
          : `(${t("components.filterSelect.all")})`;

      return `${label} ${suffix}`;
    }
    if (selectedCount === totalCount) {
      return `${label} (${t("components.filterSelect.all")})`;
    }

    return `${label} (${selectedCount})`;
  }, [label, selectedCount, totalCount, t, emptySelectionMode]);

  return (
    <Button
      onClick={onClick}
      sx={{
        fontWeight: 600,
        fontSize: 14,
        color: theme.colors.text[5],
        textDecoration: "underline",
        px: 0,
      }}
    >
      {actionText}
    </Button>
  );
};
